"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferActionsService = void 0;
exports.TransferActionsService = {
    transferActions: {},
    init(args) {
        this.transferActions = Object.assign({}, args);
    },
    navigateTo(args) {
        if (!this.transferActions.navigateTo) {
            console.error('TransferActionsService.navigateTo is not defined');
            return;
        }
        this.transferActions.navigateTo(args);
    },
    showApp() {
        if (!this.transferActions.showApp) {
            console.error('TransferActionsService.showApp is not defined');
            return;
        }
        this.transferActions.showApp();
    },
    hideApp() {
        if (!this.transferActions.hideApp) {
            console.error('TransferActionsService.hideApp is not defined');
            return;
        }
        this.transferActions.hideApp();
    },
    showDropzone() {
        if (!this.transferActions.showDropzone) {
            console.error('TransferActionsService.showDropzone is not defined');
            return;
        }
        this.transferActions.showDropzone();
    },
    closePanel() {
        if (!this.transferActions.closePanel) {
            console.error('TransferActionsService.closePanel is not defined');
            return;
        }
        this.transferActions.closePanel();
    },
};
//# sourceMappingURL=transfer-actions.service.js.map